<!--
 * @Author: your name
 * @Date: 2022-03-12 09:40:31
 * @LastEditors: onepisYa
 * @LastEditTime: 2022-03-23 10:35:27
 * @Description: file content
-->
<template>
  <div class="lottery-list">
    <van-cell-group :title="group_title" inset>
      <template v-if="value_alone">
        <div class="cancel-bottom-border">
          <van-cell
            center
            v-for="(prize, index) in values"
            :value="prize[1]"
            :key="index"
            :title="prize[0]"
            value-class="text-left"
          ></van-cell>
        </div>
      </template>
      <template v-else>
        <div class="cc">
          <van-cell
            v-for="(info, index) in user_infos"
            :value="info.prize_rank"
            :title="info.username"
            :key="index"
            center
          >
            <template v-slot:icon>
              <van-image
                round
                lazy-load
                width="4rem"
                height="4rem"
                :src="info.avatar"
                :error-icon="require('@/assets/lottery/defaultAvartar.png')"
              >
                <template v-slot:loading>
                  <van-loading type="spinner" size="20" color="#fab33b" />
                </template>
                <template v-slot:error> </template>
              </van-image>
            </template>
          </van-cell>
        </div>
      </template>
    </van-cell-group>
  </div>
</template>

<script>
  export default {
    props: {
      title: { type: String, default: "" },
      value_alone: { type: Boolean, default: () => true },
      group_title: { type: String, default: () => " " },
      user_infos: {
        type: Array,
        default: () => [],
      },
      // 当 value_alone 为 true 时，values 数组被使用，否则使用 user_infos
      values: { type: Array, default: () => [] },
    },
  };
</script>

<style lang="less" scoped>
  .error-img {
    background-image: url("~@/assets/lottery/defaultAvartar.png") no-repeat;
  }

  // 隔行换色
  .cc {
    .van-cell:nth-child(2n-1) {
      background: #fff9f3;
    }
  }
  // 取消 cell 下划线
  .cancel-bottom-border {
    .van-cell::after {
      border-bottom: none;
    }
  }
  // 文本区中
  .text-center {
    text-align: center;
  }

  // 文本区中
  .text-left {
    text-align: left;
  }
  .lottery-list {
    width: 80%;
    margin: 0 auto;
    .van-cell-group__title {
      color: #000000;
      font-size: 14px;
    }
  }
</style>
